"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Bar = _interopRequireDefault(require("./Bar"));
var BarsWrapper = function BarsWrapper(_ref) {
  var items = _ref.items,
    currency = _ref.currency,
    amountToPayPercentage = _ref.amountToPayPercentage,
    itemsColours = _ref.itemsColours,
    fullyPaid = _ref.fullyPaid,
    showCurrency = _ref.showCurrency;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "width-100% ".concat(fullyPaid ? 'd8-u-success-dark-bg' : 'd8-u-error-bg', " d8-u-radius-md flex position-relative"),
    style: {
      height: 'var(--space-xxs)'
    }
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_Bar["default"], {
      key: "".concat(i, " ").concat(JSON.stringify(items)),
      item: item,
      isFirst: i === 0,
      isLast: i !== 0 && i === items.length - 1,
      currency: currency,
      showCurrency: showCurrency,
      amountToPayPercentage: amountToPayPercentage,
      itemColourClassName: items.length === itemsColours.length && itemsColours[i]
    });
  }));
};
BarsWrapper.propTypes = {
  items: _propTypes["default"].object.isRequired,
  currency: _propTypes["default"].string.isRequired,
  showCurrency: _propTypes["default"].string,
  itemsColours: _propTypes["default"].array.isRequired,
  fullyPaid: _propTypes["default"].bool.isRequired,
  amountToPayPercentage: _propTypes["default"].number
};
var _default = exports["default"] = BarsWrapper;